import {
  AfterContentInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';

import {SliderService} from "./slider.service";

interface DefaultConfig {
  hoverScaleFactor?: number;
  keepAspectRatio?: boolean;
  useHover?: boolean;
}

@Directive({
  selector: '[appSliderElement]'
})
export class SliderElementDirective implements OnInit, OnDestroy, AfterContentInit {
  @Input() appSliderElement: DefaultConfig = {};
  private containerExceedsElements = false;
  private sliderSub = null;
  private defaultConfig = {
    hoverScaleFactor: 1.1,
    keepAspectRatio: false,
    useHover: false,
  };
  private timer = null;

  constructor(public element: ElementRef, private sliderService: SliderService, private renderer: Renderer2) {
    this.renderer.setStyle(element.nativeElement, 'display', 'inline-block');
    this.renderer.setStyle(element.nativeElement, 'position', 'relative');
    this.renderer.setStyle(element.nativeElement, 'transition', 'transform .35s ease-in-out');
    this.renderer.setStyle(element.nativeElement, 'will-change', 'transform');
    this.renderer.setStyle(element.nativeElement, 'margin', '0 5px');
  }

  ngOnInit(): void {
    this.appSliderElement = {
      ...this.defaultConfig,
      ...this.appSliderElement
    };
    if (this.appSliderElement.keepAspectRatio) {
      window.addEventListener('resize', () => this.onResize());
    }
    this.sliderSub = this.sliderService.containerExceedsElements.subscribe(containerExceedsElements => {
      this.containerExceedsElements = containerExceedsElements;
    });
  }

  ngAfterContentInit(): void {
    /*setTimeout(() => {
      this.calculateWidth();
    }, 0);*/
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', () => this.onResize());
    if (this.sliderSub) {
      this.sliderSub.unsubscribe();
    }
  }

  onResize() {
    // this.calculateWidth();
  }

  calculateWidth() {
    const {height} = this.element.nativeElement.getBoundingClientRect();
    this.renderer.setStyle(this.element.nativeElement, 'width', `${height * (16 / 9)}px`);
  }

  get nativeElement() {
    return this.element.nativeElement;
  }

  @HostListener('mouseenter', ['$event']) onMouseEnter(e) {
    e.stopPropagation();
    if (this.appSliderElement.useHover) {
      this.timer = setTimeout(() => {
        this.renderer.setStyle(this.element.nativeElement, 'transform', `scale(${this.appSliderElement.hoverScaleFactor})`);
        this.renderer.setStyle(this.element.nativeElement, 'z-index', '1');
        if (!this.containerExceedsElements) {
          this.sliderService.hideControls.next(true);
        }
      }, 550);
    }
  }

  @HostListener('mouseleave', ['$event']) onMouseLeave(e) {
    e.stopPropagation();
    if (this.appSliderElement.useHover) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.renderer.setStyle(this.element.nativeElement, 'transform', 'scale(1.0)');
    }
  }

  @HostListener('transitionend', ['$event']) onTransitionEnd(e) {
    e.stopPropagation();
    if (this.appSliderElement.useHover && this.element.nativeElement.style.transform.trim() === 'scale(1)') {
      this.renderer.setStyle(this.element.nativeElement, 'z-index', '0');
      if (!this.containerExceedsElements) {
        this.sliderService.hideControls.next(false);
      }
    }
  }
}
